/*
 * THIS FILE WAS GENERATED BY "@atproto/lex". DO NOT EDIT.
 */

export * from './createTemplate.defs.js'
export * as $defs from './createTemplate.defs.js'
